import { render, staticRenderFns } from "./MopAddButton.vue?vue&type=template&id=681abc0e"
import script from "./MopAddButton.vue?vue&type=script&lang=js"
export * from "./MopAddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports